import React from 'react'
import { useNavigate } from "react-router-dom";

import TabSpace from './tab_space.js'
import ContentSpace from './content_space.js'
import MagmaAnimation from "../animations/animation1.js";
import ColorCircles from "../animations/animation2.js";
import StarfieldAnimation from "../animations/animation3.js"
import '../home.css';

var colorSet = ["#4A5AED", "#FFC701" , "#C8FF2B", "#C31E46", "#A66C15", 
                "#4800A4", "#56FF85", "#FF3D00" , "#E37575",
                "#B27AFA", "#F90", "#727D2B", "#1AF3F3", "#DDE993", "#FF00E5"]

const RightPanel = ({ pathname }) => {

    const navigate = useNavigate()

    const goToAbout=()=>{
        navigate("/about");
    }
    const goToArt=()=>{
        navigate("/art");
    }

    const goToProjects=()=>{
        navigate("/projects");
    }

    const goToSpaces=()=>{
        navigate("/spaces");
    }

    return (
        <div className="float-right flex flex-wrap h-[100dvh]" id="rightpanel">
            <TabSpace color={colorSet[0]} pagename="about" pathname={pathname} handleClick={() => goToAbout()} id="about_space"/>
            <ContentSpace color={colorSet[1]}>
                <StarfieldAnimation/>
            </ContentSpace>
            <ContentSpace color={colorSet[2]}/>
            <TabSpace color={colorSet[3]} pagename="projects" pathname={pathname} handleClick={() => goToProjects()}/>
            <ContentSpace color={colorSet[5]}/>
            <ContentSpace color={colorSet[6]}/>
            <TabSpace color={colorSet[14]} pagename="art" pathname={pathname} handleClick={() => goToArt()}/>
            <ContentSpace color={colorSet[7]}/>
            <ContentSpace color={colorSet[8]}>
                <ColorCircles/>
            </ContentSpace>
            <TabSpace color={colorSet[11]} pagename="spaces" label="+++" pathname={pathname} handleClick={() => goToSpaces()}/>
            <ContentSpace color={colorSet[10]}/>
            <ContentSpace color={colorSet[4]}/>
            <ContentSpace color={colorSet[12]}/>
            <ContentSpace color={colorSet[13]}>
                <MagmaAnimation/>
            </ContentSpace>
            <ContentSpace color={colorSet[9]}/>
        </div>
    )
}
  

export default RightPanel